// // screens/marketplace/MarketplaceOrders.jsx
// import React, { useCallback, useEffect, useState } from "react";
// import { ReceiptText, Truck, RefreshCw, PackageX } from "lucide-react";
// import { useAuth } from "../../providers/AuthProvider";
// import {useToast} from '../../providers/ToastProvider';
// import { useTheme } from "../../hooks/useTheme";
// import {
//   PageShell,
//   Section,
//   Button,
//   Field,
//   Input,
//   EmptyState,
//   LoadingBlock,
//   parseApiError,
//   useTokens,
// } from "./shared";

// const STATUSES = ["PROCESSING", "SHIPPED", "DELIVERED", "COMPLETED", "FAILED", "CANCELLED"];

// export default function MarketplaceOrders() {
//   const { authFetch, user } = useAuth();
//   const { showToast } = useToast();
//   const t = useTokens();

//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [tracking, setTracking] = useState({});
//   const [busyId, setBusyId] = useState(null);

//   const admin = user?.role === "ADMIN";

//   const load = useCallback(async () => {
//     try {
//       const res = await authFetch("/marketplace/orders/");
//       const data = await res.json();
//       if (res.ok) setOrders(data.data || []);
//       else showToast(parseApiError(data), "error");
//     } catch {
//       showToast("Could not load orders", "error");
//     } finally {
//       setLoading(false);
//     }
//   }, [authFetch, showToast]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   const updateStatus = async (order, status) => {
//     setBusyId(order.id);
//     try {
//       const res = await authFetch(`/marketplace/orders/${order.id}/status/`, {
//         method: "PATCH",
//         body: JSON.stringify({ status, ...tracking[order.id] }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(parseApiError(data));
//       showToast(`Order marked ${status.toLowerCase()}`, "success");
//       load();
//     } catch (err) {
//       showToast(err.message, "error");
//     } finally {
//       setBusyId(null);
//     }
//   };

//   const refund = async (order) => {
//     if (!window.confirm("Refund this order? This cannot be undone.")) return;
//     setBusyId(order.id);
//     try {
//       const res = await authFetch(
//         `/marketplace/orders/${order.id}/refund/`,
//         { method: "POST" }
//       );
//       if (!res.ok) {
//         const d = await res.json().catch(() => ({}));
//         throw new Error(parseApiError(d));
//       }
//       showToast("Order refunded", "success");
//       load();
//     } catch (err) {
//       showToast(err.message, "error");
//     } finally {
//       setBusyId(null);
//     }
//   };

//   return (
//     <PageShell
//       eyebrow="Fulfilment"
//       title="Marketplace orders"
//       subtitle={
//         admin
//           ? "Update status, add tracking references, and issue refunds."
//           : "Read-only view of orders placed through your storefront."
//       }
//       actions={
//         <Button variant="secondary" icon={RefreshCw} onClick={load} disabled={loading}>
//           Refresh
//         </Button>
//       }
//     >
//       <Section
//         title="Orders"
//         icon={ReceiptText}
//         chip={`${orders.length}`}
//       >
//         {loading ? (
//           <LoadingBlock />
//         ) : orders.length === 0 ? (
//           <EmptyState
//             icon={PackageX}
//             title="No orders yet"
//             description={
//               admin
//                 ? "Orders will appear here as customers check out."
//                 : "Orders attributed to your store will show here."
//             }
//           />
//         ) : (
//           <div style={{ display: "grid", gap: 12 }}>
//             {orders.map((o) => (
//               <OrderCard
//                 key={o.id}
//                 order={o}
//                 admin={admin}
//                 busy={busyId === o.id}
//                 tracking={tracking[o.id] || {}}
//                 setTracking={(patch) =>
//                   setTracking((prev) => ({
//                     ...prev,
//                     [o.id]: { ...(prev[o.id] || {}), ...patch },
//                   }))
//                 }
//                 onStatus={updateStatus}
//                 onRefund={refund}
//                 t={t}
//               />
//             ))}
//           </div>
//         )}
//       </Section>
//     </PageShell>
//   );
// }

// const OrderCard = ({
//   order,
//   admin,
//   busy,
//   tracking,
//   setTracking,
//   onStatus,
//   onRefund,
//   t,
// }) => {
//   const isPaid = order.payment_status === "COMPLETED";
//   return (
//     <article
//       style={{
//         border: `1px solid ${t.border}`,
//         borderRadius: 14,
//         padding: 18,
//         background: t.surfaceRaised,
//         opacity: busy ? 0.65 : 1,
//         transition: "opacity 0.15s ease",
//       }}
//     >
//       <header
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           gap: 14,
//           flexWrap: "wrap",
//           alignItems: "flex-start",
//           marginBottom: 14,
//         }}
//       >
//         <div style={{ minWidth: 0 }}>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 10,
//               flexWrap: "wrap",
//             }}
//           >
//             <span
//               style={{
//                 fontFamily: "ui-monospace, monospace",
//                 fontSize: 12.5,
//                 fontWeight: 700,
//                 padding: "3px 8px",
//                 borderRadius: 6,
//                 background: t.subtle,
//                 color: t.heading,
//               }}
//             >
//               #{order.id.slice(0, 8)}
//             </span>
//             <span
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 padding: "3px 9px",
//                 borderRadius: 999,
//                 background: t.subtle,
//                 color: t.muted,
//                 textTransform: "uppercase",
//                 letterSpacing: "0.04em",
//               }}
//             >
//               {order.status_display || order.status}
//             </span>
//             <span
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 padding: "3px 9px",
//                 borderRadius: 999,
//                 background: isPaid ? t.successBg : t.warningBg,
//                 color: isPaid ? t.success : t.warning,
//                 textTransform: "uppercase",
//                 letterSpacing: "0.04em",
//               }}
//             >
//               {order.payment_status}
//             </span>
//           </div>
//           <div
//             style={{
//               marginTop: 8,
//               fontSize: 13,
//               color: t.muted,
//               lineHeight: 1.5,
//             }}
//           >
//             {order.customer_username} ·{" "}
//             {order.order_type_display || order.order_type}
//           </div>
//         </div>
//         <div
//           style={{
//             fontSize: 20,
//             fontWeight: 800,
//             color: t.heading,
//             letterSpacing: "-0.01em",
//           }}
//         >
//           GH₵{Number(order.total).toFixed(2)}
//         </div>
//       </header>

//       {admin && (
//         <>
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
//               gap: 10,
//               marginBottom: 14,
//             }}
//           >
//             <Field label="Tracking number">
//               <Input
//                 placeholder="e.g. AZ-082931"
//                 value={tracking.tracking_number || ""}
//                 onChange={(e) =>
//                   setTracking({ tracking_number: e.target.value })
//                 }
//               />
//             </Field>
//             <Field label="Tracking URL">
//               <Input
//                 placeholder="https://…"
//                 value={tracking.tracking_url || ""}
//                 onChange={(e) =>
//                   setTracking({ tracking_url: e.target.value })
//                 }
//               />
//             </Field>
//           </div>

//           <div
//             style={{
//               display: "flex",
//               gap: 8,
//               flexWrap: "wrap",
//               paddingTop: 12,
//               borderTop: `1px solid ${t.separator}`,
//             }}
//           >
//             {STATUSES.map((s) => (
//               <Button
//                 key={s}
//                 size="sm"
//                 variant="secondary"
//                 icon={s === "SHIPPED" ? Truck : undefined}
//                 onClick={() => onStatus(order, s)}
//                 disabled={busy || order.status === s}
//               >
//                 {s}
//               </Button>
//             ))}
//             {isPaid && (
//               <Button
//                 size="sm"
//                 variant="dangerGhost"
//                 onClick={() => onRefund(order)}
//                 disabled={busy}
//               >
//                 Refund
//               </Button>
//             )}
//           </div>
//         </>
//       )}
//     </article>
//   );
// };

















// screens/marketplace/MarketplaceOrders.jsx
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ReceiptText,
  RefreshCw,
  PackageX,
  ChevronRight,
  Truck,
  Clock,
  CheckCircle2,
  XCircle,
} from "lucide-react";
import { useAuth } from "../../providers/AuthProvider";
import { useToast } from "../../providers/ToastProvider";
import {
  PageShell,
  Section,
  Button,
  EmptyState,
  LoadingBlock,
  useTokens,
} from "./shared";

/* ══════════════════════════════════════════════════════════
   Read-only order list for buyers.
   Clicking any order opens /marketplace/orders/{id} where the
   full per-item view (statuses + shipping payment) lives.
   ══════════════════════════════════════════════════════════ */

const STATUS_FLOW = [
  { value: "ORDER_CONFIRMED", label: "Order Confirmed" },
  { value: "SHOPPING_IN_PROGRESS", label: "Shopping in Progress" },
  { value: "PURCHASED", label: "Purchased" },
  { value: "IN_TRANSIT_TO_CHINA", label: "In Transit to China Warehouse" },
  { value: "RECEIVED_AT_CHINA", label: "Received at China Warehouse" },
  { value: "INSPECTION_IN_PROGRESS", label: "Inspection in Progress" },
  { value: "PREPARING_FOR_SHIPMENT", label: "Preparing for Shipment" },
  { value: "SHIPPED_FROM_CHINA", label: "Shipped from China" },
  { value: "ARRIVED_IN_GHANA", label: "Arrived in Ghana" },
  { value: "READY_FOR_PICKUP", label: "Ready for Pickup" },
  { value: "OUT_FOR_DELIVERY", label: "Out for Delivery" },
  { value: "DELIVERED_SUCCESSFULLY", label: "Delivered Successfully" },
];

const STATUS_BY_VALUE = Object.fromEntries(
  STATUS_FLOW.map((s, i) => [s.value, { ...s, index: i }])
);

const statusMeta = (value) => {
  if (value === "FAILED")
    return { label: "Failed", tone: "error", icon: XCircle };
  if (value === "CANCELLED")
    return { label: "Cancelled", tone: "muted", icon: XCircle };
  const s = STATUS_BY_VALUE[value];
  if (!s) return { label: value || "Unknown", tone: "muted", icon: Clock };
  const idx = s.index;
  if (idx >= 11) return { label: s.label, tone: "success", icon: CheckCircle2 };
  if (idx >= 8) return { label: s.label, tone: "warning", icon: Truck };
  return { label: s.label, tone: "muted", icon: Clock };
};

const toneColors = (t, tone) => {
  const map = {
    success: { fg: t.success, bg: t.successBg },
    warning: { fg: t.warning, bg: t.warningBg },
    error: { fg: t.error, bg: t.errorBg },
    muted: { fg: t.muted, bg: t.subtle },
  };
  return map[tone] || map.muted;
};

const money = (v) => `GH₵${Number(v || 0).toFixed(2)}`;

const readApiError = (data, fallback) => {
  if (!data) return fallback;
  if (data.message) return data.message;
  const errs = data.errors;
  if (errs) {
    const parts = [];
    for (const [key, val] of Object.entries(errs)) {
      const arr = Array.isArray(val) ? val : [val];
      arr.forEach((msg) => {
        if (key === "non_field_errors" || key === "detail") parts.push(msg);
        else parts.push(`${key.replace(/_/g, " ")}: ${msg}`);
      });
    }
    if (parts.length) return parts.join(" ");
  }
  return fallback;
};

export default function MarketplaceOrders() {
  const { authFetch } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const t = useTokens();

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const load = useCallback(
    async ({ silent } = {}) => {
      if (!silent) setLoading(true);
      else setRefreshing(true);
      try {
        const res = await authFetch("/marketplace/orders/");
        const data = await res.json();
        if (!res.ok) throw new Error(readApiError(data, "Could not load orders"));
        setOrders(data.data || []);
      } catch (err) {
        showToast(err.message, "error");
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    },
    [authFetch, showToast]
  );

  useEffect(() => {
    load();
  }, [load]);

  /* Prefer the backend roll-up status. Fall back to the local map
     if only an item-level status is present. */
  const totalOrders = orders.length;
  const pendingShipping = useMemo(() => {
    let count = 0;
    orders.forEach((o) => {
      (o.items || []).forEach((item) => {
        const idx = STATUS_BY_VALUE[item.status]?.index ?? -1;
        const arrived = idx >= 8;
        const paid = item.shipping_payment_status === "COMPLETED";
        const hasFee = Number(item.shipping_fee) > 0;
        if (arrived && !paid && hasFee) count += 1;
      });
    });
    return count;
  }, [orders]);

  return (
    <PageShell
      eyebrow="My orders"
      title="Order history"
      subtitle="Track every purchase and pay shipping once items arrive in Ghana."
      actions={
        <Button
          variant="secondary"
          icon={RefreshCw}
          onClick={() => load({ silent: true })}
          disabled={refreshing}
        >
          Refresh
        </Button>
      }
    >
      {/* Attention strip */}
      {pendingShipping > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "12px 14px",
            borderRadius: 12,
            background: t.warningBg,
            border: `1px solid ${t.warning}55`,
            marginBottom: 16,
          }}
        >
          <span
            style={{
              width: 32,
              height: 32,
              borderRadius: 9,
              background: t.warning,
              color: "#fff",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Truck size={16} />
          </span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                fontSize: 13,
                fontWeight: 800,
                color: t.heading,
              }}
            >
              {pendingShipping} item{pendingShipping === 1 ? "" : "s"} ready for
              shipping payment
            </div>
            <div style={{ fontSize: 12, color: t.muted, marginTop: 2 }}>
              Open the order and pay shipping to have them released.
            </div>
          </div>
        </div>
      )}

      <Section
        title="Orders"
        icon={ReceiptText}
        chip={`${totalOrders}`}
      >
        {loading ? (
          <LoadingBlock label="Loading orders…" />
        ) : orders.length === 0 ? (
          <EmptyState
            icon={PackageX}
            title="No orders yet"
            description="Your marketplace purchases will show here."
          />
        ) : (
          <div style={{ display: "grid", gap: 10 }}>
            {orders.map((order) => (
              <OrderCard
                key={order.id}
                order={order}
                t={t}
                onOpen={() => navigate(`/marketplace/orders/${order.id}`)}
              />
            ))}
          </div>
        )}
      </Section>
    </PageShell>
  );
}

/* ══════════════════════════════════════════════════════════
   OrderCard — read-only summary, tap to open
   ══════════════════════════════════════════════════════════ */

const OrderCard = ({ order, t, onOpen }) => {
  const items = order.items || [];
  const meta = statusMeta(order.status);
  const tone = toneColors(t, meta.tone);
  const grandTotal =
    order.grand_total ??
    (Number(order.total || 0) + Number(order.shipping_fee || 0));

  /* Show how many items still need shipping payment */
  const pendingShipping = items.filter((item) => {
    const idx = STATUS_BY_VALUE[item.status]?.index ?? -1;
    return (
      idx >= 8 &&
      item.shipping_payment_status !== "COMPLETED" &&
      Number(item.shipping_fee) > 0
    );
  }).length;

  /* Preview of the first 1-2 products in the order */
  const preview = items.slice(0, 2);
  const extra = Math.max(0, items.length - preview.length);

  return (
    <button
      type="button"
      onClick={onOpen}
      style={{
        display: "block",
        width: "100%",
        textAlign: "left",
        border: `1px solid ${t.border}`,
        borderRadius: 14,
        padding: 16,
        background: t.surfaceRaised,
        cursor: "pointer",
        fontFamily: "inherit",
        transition: "border-color 0.15s ease, transform 0.15s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = t.accent;
        e.currentTarget.style.transform = "translateY(-1px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = t.border;
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 12,
          flexWrap: "wrap",
          marginBottom: 12,
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <span
              style={{
                fontFamily: "ui-monospace, monospace",
                fontSize: 12,
                fontWeight: 700,
                padding: "3px 8px",
                borderRadius: 6,
                background: t.subtle,
                color: t.heading,
              }}
            >
              #{String(order.id).slice(0, 8)}
            </span>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                fontSize: 10.5,
                fontWeight: 800,
                padding: "3px 9px",
                borderRadius: 999,
                background: tone.bg,
                color: tone.fg,
                textTransform: "uppercase",
                letterSpacing: 0.3,
              }}
            >
              <meta.icon size={10} />
              {order.status_display || meta.label}
            </span>
            {pendingShipping > 0 && (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  fontSize: 10.5,
                  fontWeight: 800,
                  padding: "3px 9px",
                  borderRadius: 999,
                  background: t.warningBg,
                  color: t.warning,
                  textTransform: "uppercase",
                  letterSpacing: 0.3,
                }}
              >
                <Truck size={10} />
                Shipping due
              </span>
            )}
          </div>
          <div
            style={{
              marginTop: 6,
              fontSize: 12,
              color: t.muted,
            }}
          >
            {new Date(order.created_at).toLocaleDateString(undefined, {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
            {items.length > 0 &&
              ` · ${items.length} item${items.length === 1 ? "" : "s"}`}
          </div>
        </div>

        <div
          style={{
            fontSize: 18,
            fontWeight: 800,
            color: t.heading,
            letterSpacing: "-0.01em",
            flexShrink: 0,
          }}
        >
          {money(grandTotal)}
        </div>
      </header>

      {preview.length > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          {preview.map((item) => (
            <span
              key={item.id}
              style={{
                fontSize: 12,
                color: t.text,
                padding: "4px 10px",
                borderRadius: 999,
                background: t.subtle,
                fontWeight: 600,
                maxWidth: 220,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {item.product_name_display || item.product_name} ×{item.quantity}
            </span>
          ))}
          {extra > 0 && (
            <span style={{ fontSize: 12, color: t.muted, fontWeight: 600 }}>
              +{extra} more
            </span>
          )}
          <div style={{ flex: 1 }} />
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              fontSize: 12.5,
              fontWeight: 700,
              color: t.accent,
            }}
          >
            View order <ChevronRight size={14} />
          </span>
        </div>
      )}
    </button>
  );
};